export enum ScheduleViewMode {
  Day = 'day',
  Week = 'week',
  Month = 'month',
}
